import Vue from 'vue'

import 'core/mapping'
import 'core/timestamps'
import 'core/charts'
import 'core/fontawesome'
import settings from 'core/settings'

import apolloProvider from 'core/apollo'

import App from '../species/App.vue'

document.addEventListener('DOMContentLoaded', () => {
  const target = document.getElementById('app')
  if (!target) return

  new Vue({
    apolloProvider,
    store: settings,
    render: h => h(App, {
      props: {
        species: JSON.parse(target.dataset.species)
      }
    })
  }).$mount(target)
})
